<template>
	<div class="button_wrapper">
		<button
			v-for="(item, index) in interestMenuList"
			:key="index"
			type="button"
			class="btn_box"
			@click="onClickMenu(item.path)"
		>
			<img v-if="item.title === '한국주식'" src="@/assets/img/common/southkorea.svg" loading="lazy" alt="한국국기" />
			<img v-else-if="item.title === '미국주식'" src="@/assets/img/common/america.svg" loading="lazy" alt="미국국기" />
			<img v-else-if="item.title === '일본주식'" src="@/assets/img/common/japan.svg" loading="lazy" alt="일본국기" />
			<span>{{ item.title }}</span>
		</button>
	</div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';

import { interestMenuList } from '@/constants/menu';

const router = useRouter();

const onClickMenu = (path: string) => {
	document.body.classList.remove('hidden');
	router.push(path);
};
</script>

<style lang="scss" scoped>
.button_wrapper {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1rem;
	
	// 모바일에서는 세로로 배치
	@media screen and (max-width: 768px) {
		grid-template-columns: 1fr;
	}
	
	.btn_box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 1rem;
		height: 14.3rem;
		background: var(--color-primary);
		border-radius: 0.8rem;
		font-size: var(--font-s-large);
		font-weight: var(--font-w-bold);
		line-height: 25px;
		
		// 모바일에서는 높이 조정
		@media screen and (max-width: 768px) {
			height: 10rem;
			flex-direction: row;
			gap: 1.5rem;
			justify-content: flex-start;
			padding: 0 2rem;
		}
		
		img {
			width: 4.8rem;
			height: 4.8rem;
			
			// 모바일에서는 크기 조정
			@media screen and (max-width: 768px) {
				width: 3.2rem;
				height: 3.2rem;
			}
		}
	}
}
</style>
